import styled from 'styled-components';
import { IColumnsDevice } from './types';

export const TableContainer = styled.div<{
  colorScroll: string;
  scrollActiveAt: string;
}>`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #d5e5f0;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
  width: 100%;

  // scroll horizontal en pantallas menores a 992px
  @media (max-width: ${({ scrollActiveAt }) => scrollActiveAt}) {
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: auto;
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ colorScroll }) => colorScroll};
      border-radius: 4px;
    }
  }
`;

export const TableHeader = styled.div<{
  columns: IColumnsDevice;
  alignments: string[];
  scrollActiveAt: string;
}>`
  display: grid;
  grid-template-columns: ${({ columns }) => columns?.deviceLG?.join(' ')};
  gap: 12px;
  align-items: center;
  padding: 16px;
  background-color: #eff6ff;
  color: #161d1f;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;

  & > div {
    text-align: ${({ alignments }) => alignments.join(' ')};
  }

  @media (639.5px <= width <= 740px) {
    justify-content: space-between;
    grid-template-columns: ${({ columns }) => columns?.deviceSM?.join(' ')};
  }

  @media (max-width: ${({ scrollActiveAt }) => scrollActiveAt}) {
    width: max-content;
  }

  @media (640px <= width <= 767.5px) {
    justify-content: space-between;
    grid-template-columns: ${({ columns }) => columns?.deviceMD?.join(' ')};
    gap: 16px;
  }

  @media (768px <= width <= 991.5px) {
    justify-content: space-between;
    grid-template-columns: ${({ columns }) => columns?.deviceLG?.join(' ')};
    gap: 16px;
  }

  @media (min-width: 991.5px) {
    grid-template-columns: ${({ columns }) => columns?.deviceXL?.join(' ')};
  }
`;

export const TableBody = styled.div<{ expanded?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ expanded }) => (expanded ? '#d5e5f0' : '#fff')};
`;

export const TableRow = styled.div<{
  columns: IColumnsDevice;
  scrollActiveAt: string;
}>`
  display: grid;
  grid-template-columns: ${({ columns }) => columns?.deviceLG?.join(' ')};
  align-items: center;
  padding: 12px 16px;
  color: #161d1f;
  font-size: 14px;
  font-weight: 400;
  gap: 12px;
  background-color: #ffffff;
  border-top: 1px solid #d5e5f0;
  line-height: 20px;

  &.expanded {
    font-weight: 700;
    background-color: #d5e5f0;
  }

  &.disabled {
    // cursor: no-drop;
    color: #8090bb;
  }

  @media (639.5px <= width <= 740px) {
    justify-content: space-between;
    grid-template-columns: ${({ columns }) => columns?.deviceSM?.join(' ')};
  }

  @media (max-width: ${({ scrollActiveAt }) => scrollActiveAt}) {
    width: max-content;
  }

  @media (640px <= width <= 767.5px) {
    justify-content: space-between;
    grid-template-columns: ${({ columns }) => columns?.deviceMD?.join(' ')};
    gap: 16px;
  }

  @media (768px <= width <= 991.5px) {
    justify-content: space-between;
    grid-template-columns: ${({ columns }) => columns?.deviceLG?.join(' ')};
    gap: 16px;
  }

  @media (min-width: 991.5px) {
    grid-template-columns: ${({ columns }) => columns?.deviceXL?.join(' ')};
  }
`;
